import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AcuerdoPagoComponent } from "./components/acuerdo-pago/acuerdo-pago.component";

const routes: Routes = [
    {
      path: "acuerdo-pago",
      component: AcuerdoPagoComponent,
      data: {
        title: 'Acuerdo Pago'
      }
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class AcuerdoPagoRoutingModule { }